import { environment, WmCommandProvider } from "@wms/app";
import { inject, Injectable, OnDestroy } from "@angular/core";
import {ActivatedRoute, Router} from "@angular/router";
import { Location } from "@angular/common";
import {
  MarkupManagerService,
  getDecodedData,
  hasSpecialCharacters, isDuplicateName, getCanvasElement
} from "@wms/core";
import {$invokeWatchers, getValidJSON, isDefined} from "@wm/core";
import {assign, each, extend, find, forEach, get, isEmpty, isEqual, isObject, isString, map, trim} from "lodash-es";
import {
  FileService,
  I18nService,
  NotificationService,
  PageService,
  ProjectService,
  TreeService,
  WmHttpService
} from "@wms/services";
import {EventManagerService} from "@wms/app";
import { PageLayoutsService } from './services/pageLayoutsService';
import {IWMSStandaloneEditorConstructionOptions, WMSEditorComponent} from "@wms/components";
import { Subscription } from "rxjs";
import { WS, PageDetails} from "@wms/page-workspace";
import { AppManagerService, AppResourceManagerService, WmsCanvasDomComponent } from "@wms/design-container";
import { runtimeEventManager } from "@wm/core";
import {PropertiesPanelComponent} from "@wms/properties-panel";
import { BaseVariableService } from "@wms/variables";
import { WmsWorkspaceManagerService } from "@wms/app/workspace";
import {IssuesService} from "@wms/app/bottom-left-menu/components/issues/issues.service";
import {getWidgetRegistry} from "@wm/components-base";

const PAGE_DIRECTORY = "../../../pages/";
let TABS = {
    'DESIGN': 'DESIGN',
    'MARKUP': 'MARKUP',
    'SCRIPT': 'SCRIPT',
    'STYLE': 'STYLE',
    'VARIABLES': 'VARIABLES'
  },
  layoutWidgetTypes = {
    'wm-header'        : 'HEADER',
    'wm-footer'        : 'FOOTER',
    'wm-left-panel'    : 'LEFTNAV',
    'wm-right-panel'   : 'RIGHTNAV',
    'wm-top-nav'       : 'TOPNAV'
  };
const  editorPosition: { currentPosition: any, currentSelectionRange: any, currentScrollTop: any, currentScrollLeft: any } = { currentPosition: null, currentSelectionRange: null, currentScrollTop: null, currentScrollLeft: null };
const PAGE = 'PAGE';
interface GroupThemes {
  label: string;
  themes: {
    name: string;
    value: string;
  }[];
}


let _activeWS: WS = {
  active: true,
  details: {pageName: 'Main', tab: 'DESIGN', icon: 'wms wms-page'},
  identifier: "PAGE:Main",
  name: "Main",
  type: "PAGE"
};
let activePageName: string = '';

@Injectable({
  providedIn: 'root'
})
export class PageWsService implements OnDestroy {
  private wmCommand: WmCommandProvider;
  isWmEventTriggered: boolean = false;
  public  savedStackLength: number = 0;
  savedEditorContent:string='';
  public  showAutoSave: boolean = false;
  public widgetPropertyChanged: boolean = false;
  private fileService: FileService;
  private wmHttpService: WmHttpService;
  public projectService: ProjectService;
  private eventManager: EventManagerService;
  private isPageParamsUpdated: boolean;
  private pageService: PageService;
  private baseVariableService: BaseVariableService;
  public pageParams: any;
  private newPageLayouts: any;
  public layout: any;
  public pageInfo: any = {};
  public activePageInfo: any;
  public activePageName: string;
  public previousPageName: string;
  public newParam = {name: '', type: 'string'}
  private locale: any;

  public markupUpdated: boolean = false;

  public template: any = {};
  public createdVariable = {};
  public templateWidgets = {};
  private pageLayoutService: PageLayoutsService;
  public activeTab: any;
  public saveVariables: boolean;
  public editor: WMSEditorComponent;
  private registerDestroyListener = new Subscription();
  private treeService: TreeService;
  private appManager: AppManagerService;
  private selectedPageName: string;
  private workspaceManager: WmsWorkspaceManagerService;
  pageSearchKey:any
  availableDevices:any
  layoutOptions:any
  templateMenu: any = { show: this.showTemplateMenu.bind(this), visible: false };
  showHiddenElements: boolean = localStorage.getItem("showHiddenElements") === "true" ? true : false;
  hiddenElementsExist: boolean = false;
  selectedViewPort:any;
  showCanvasFitScreen:boolean;
  editorOptions: IWMSStandaloneEditorConstructionOptions = {};
  groupThemes: GroupThemes[] = [];
  hideResources: boolean = false;
  hideEditorProperties: boolean = false;
  isActivetabDesign:string;
  selectedTab:string;
  pageSubCategory:string ='';
  handelExpaindCollapse:boolean = false;
  private saveTimeout?: any;
  private isSaving:boolean;
  private readonly SAVE_INTERVAL = 5000;





  constructor(private route: ActivatedRoute, private router: Router, private location: Location,
              private resourceMngr: AppResourceManagerService, private markupManager: MarkupManagerService,
              private i18nservice: I18nService, private notificationService: NotificationService,
              private issuesService: IssuesService) {
    this.wmCommand = inject(WmCommandProvider);
    this.fileService = inject(FileService);
    this.wmHttpService = inject(WmHttpService);
    this.projectService = inject(ProjectService);
    this.eventManager = inject(EventManagerService);
    this.pageService = inject(PageService);
    this.baseVariableService = inject(BaseVariableService);
    this.pageLayoutService = inject(PageLayoutsService);
    this.treeService = inject(TreeService);
    this.appManager = inject(AppManagerService);
    this.workspaceManager = inject(WmsWorkspaceManagerService);
    this.newPageLayouts = this.pageLayoutService.getPageLayouts();
    this.locale = i18nservice.getMessages();

    this.registerDestroyListener.add(runtimeEventManager.on('setEditorValue').subscribe((script: string) => {
      let activeTab = this.activeTab || 'DESIGN';
      if(activeTab === TABS.SCRIPT) {
        this.editor.setEditorValue(script);
      } else {
        let fileLocalURL: string = this.getFileUrl(this.activePageName, TABS.SCRIPT);
        this.saveFileContent(fileLocalURL, script).then(() => {
            this.notificationService.show("success", this.locale.MESSAGE_SUCCESS_TITLE, this.locale.MESSAGE_SUCCESS_SAVE_PREFAB_SETTINGS);
          }
        ).catch(() => {
          this.notificationService.show("error", this.locale.MESSAGE_ERROR_TITLE, this.locale.MESSAGE_FAILURE_SAVE_PREFAB_SETTINGS);
        });
      }
    }));
    this.registerDestroyListener.add(this.eventManager.beforePageRenderObservable().subscribe(() => {
      /* clear views of previous page
                     -- Whenever new page is loaded in studio mode, views of previous page should be destroyed from current scope
                     */
      // TODO: need to implement ViewService - for dialogs (not partials) - check if we are still using this service or not
      // ViewService.clearViews();
    }));

    runtimeEventManager.off('assignParams');
    this.registerDestroyListener.add(runtimeEventManager.on('assignParams').subscribe((widget) => {
      this.assignParams(widget);
    }));
    runtimeEventManager.setService('projectService', this.projectService);
    runtimeEventManager.setService('pageService', this.pageService);
    runtimeEventManager.setService('pageWSService', this);

    runtimeEventManager.setService('fileService', this.fileService);

    this.registerDestroyListener.add(this.eventManager.pageSaveObservable().subscribe((skipDirtyCheck: boolean) => {
      if (isDefined(skipDirtyCheck)) {
        this.saveActiveTabContent(skipDirtyCheck);
      } else {
        this.saveActiveTabContent(true);
      }
    }));

    this.eventManager.savePageWorkspaceObservable().subscribe((successCallback: Function) => {
      this.saveActiveTabContent(false).then(() => successCallback());
    });

    this.registerDestroyListener.add(this.eventManager.selectPageObservable().subscribe((data: string) => {
      this.selectedPageName = data;
    }));

    let registerObs = this.eventManager.pageRenderedObservable().subscribe((response) => {
      this.activeTab = TABS.DESIGN;
      this.workspaceManager.updateWSDetails(_activeWS);
      registerObs.unsubscribe();
    });

    this.loadPages();
  }

  loadPages() {
    let details = this.projectService.getDetails();
    let currentPath: string | undefined = get(this.route, '_routerState.snapshot.url') || this.location.path();
    let pageName;
    if (currentPath) {
      let matches = (currentPath as string).match(/^(\/page\/)(.*)\?/);
      if (matches && matches.length)
      pageName = matches[2];
    }

    if (details) {
      _activeWS.name = pageName || details.properties.homePage;
      _activeWS.identifier = "PAGE:" + _activeWS.name;
      _activeWS.details.pageName = _activeWS.name;
      this.setActivePageName(_activeWS.name);
      // populate the page info.
      this.projectService.getPagesList().then(() => {
        this.populatePageInfo(_activeWS.name);
        this.pageParamsInit(_activeWS.name || '');
      });
    }
    this.workspaceManager.setActiveWS(_activeWS);
  }

  setActivePageName(pageName: string) {
    this.activePageName = pageName;
    this.pageService.setActivePageName(pageName);
  }

  isDirty() {
    let _isDirty = false;
    if (this.activeTab === TABS.DESIGN) {
      _isDirty = this.savedStackLength  !== this.wmCommand.getUndoStackLength() || this.widgetPropertyChanged;
    } else if (this.editor) {
      if (this.editor.didWMSEditorContentChange()) {
        _isDirty = true;
      } else {
        const model = this.editor.wmsEditorModel;
        if (this.savedEditorContent.length && model && !model.isDisposed()) {
          const currentContent = model.getValue();
          _isDirty = this.savedEditorContent !== currentContent;
        }
      }
    }
    this.workspaceManager.setDirtyonWs(_isDirty);
    return _isDirty;
  }

  // checks the pagename comment marker.
  isValidPageContent(): boolean {
    let markup = this.markupManager.getMarkup();
    if (markup) {
      let childNode = markup[0];
      if (childNode.getAttribute('pageName') === this.selectedPageName) {
        return true;
      }
    }
    return false;
  }

  getModifiedContent(tab: string) {
    if (tab === TABS.DESIGN) {
      return this.markupManager.getDecoratedMarkup();
    }
    // Use editor model value as source of truth - options.value can be stale during rapid tab switches
    // (e.g. markup content overwriting options when saving script tab)
    if (this.editor?.wmsEditorModel && !this.editor.wmsEditorModel.isDisposed()) {
      return this.editor.wmsEditorModel.getValue();
    }
    return this.editor?.options.value;
  }

  async prettifyContent(content: string, editorLang: string ,editorOptions?:any): Promise<string> {
    const langMap: { [key: string]: string } = {
        [TABS.DESIGN]: 'html',
        [TABS.MARKUP]: 'html',
        [TABS.SCRIPT]: 'javascript',
        [TABS.STYLE]: 'css',
        [TABS.VARIABLES]: 'json',
    };
    const lang = langMap[editorLang] || 'plaintext';
    return await this.editor.triggerFormat(content, lang, editorOptions);
}


  setActiveWs(pageName: string, tab?: string) {
    let isPartial: boolean = false;
    if (this.pageInfo?.name !== pageName) {
      let pageInfo = this.projectService.getPageInfo(pageName);
      isPartial = pageInfo.type !== PAGE;
    } else {
      isPartial = this.pageInfo.isPartial;
    }
    _activeWS = {
      active: true,
      details: {pageName: pageName, tab: tab || 'DESIGN', icon: isPartial ? 'partial' : 'page'},
      identifier: "PAGE:" + pageName,
        name: pageName,
        type: "PAGE"
    }
    this.workspaceManager.updateWSDetails(_activeWS);
  }

  switchTab(tab: string, details: PageDetails = {}): Promise<any> {
    return this.saveActiveTabContent()
      .then(() => {
        let pgName: string = details.pageName || this.activePageName;
        this.resetActiveWidget();
        details = assign({'pageName': pgName, 'tab': tab}, details);
        this.pageParamsInit(details.pageName || '');
        // TODO: WIDGET_TEMPLATE_CREATE add load(details) when it is template type.
        if(tab === TABS.DESIGN ) {
          this.eventManager.emitOnTabSwitchForNav();
        }
        return ((tab === TABS.DESIGN && !details.isTemplate) ? this.loadFiles(pgName, false) : this.load(details))
          .then(async () => {
            // postWSRender has to be invoked for any tab we switch hence moving this method into .then callback.
            this.postWSRender(details);
            this.setActiveWs(pgName, tab);
            this.populatePageInfo(pgName);
            this.activeTab = tab;
            this.eventManager.emitUpdateTabOnWs({pgName, tab});
            // this.ws.updateActiveWSDetails({'tab': tab});
          }, (err: any) => {
            return Promise.reject(err)
          });
      });
  }

  saveActiveTabContent = async (skipDirtyCheck?: boolean, skipPrettify?: boolean): Promise<any> => {
    let content: any,
      prettifiedContent: any;
    const currentStackLength = this.wmCommand.getUndoStackLength();
    $invokeWatchers(true);
    // check if page is deleted before saving the page that was already deleted.
    let isPageExists = this.pageService.pages?.find((p: any) => {return p.name === this.activePageName});
    if (!isPageExists) {
      return Promise.resolve();
    }
    if (!skipDirtyCheck && !this.isDirty()) {
      // TODO: add variables save
      // if ($rs.saveVariables) {
      //   Variables.saveVariables($rs.activePageName, function () {
      //     $rs.saveVariables = false;
      //     updatePageParams()
      //       .then(function () {
      //         deferred.resolve();
      //       }, deferred.reject);
      //   }, deferred.reject);
      // } else {
      this.updatePageParams();
      //     .then(function () {
      //       deferred.resolve();
      //     }, deferred.reject);
      // }
    } else {
      if (this.activeTab === TABS.DESIGN) {
        let isValid = this.isValidPageContent();
        if (!isValid) {
          console.error('File name: ' + this.selectedPageName + ' and saving markup content is not the same.');
          console.error(this.markupManager.getMarkup());
          throw Error(`File name: ${this.selectedPageName} is not having its own page content`);
          this.eventManager.emitOnPageSave(this.activePageName);
          return Promise.resolve();
        }
      }

      this.eventManager.emitOnCanvasMarkupDirty(this.activePageName);
      content = this.getModifiedContent(this.activeTab);

      if (this.activeTab === TABS.VARIABLES) {
        content = trim(content);
        if (content === '') {
          content = {};
        } else {
          content = getValidJSON(content);
          if (!content) {
            // wmToaster.show('error', $rs.locale.MESSAGE_ERROR_TITLE, $rs.locale.MESSAGE_ERROR_INVALID_JSON);
            // deferred.reject();
            return Promise.reject();
          }
        }
      }

      if (this.editor.wmsEditor) {
        editorPosition.currentPosition = this.editor.wmsEditor.getPosition();
        editorPosition.currentSelectionRange = this.editor.wmsEditor.getSelection();
        editorPosition.currentScrollTop = this.editor.wmsEditor.getScrollTop();
        editorPosition.currentScrollLeft = this.editor.wmsEditor.getScrollLeft();
      }
      if(this.projectService.isPrettificationEnabled() && !skipPrettify) {
        prettifiedContent = await this.prettifyContent(content, _activeWS.details.tab as string, this.activeTab !== TABS.DESIGN? editorPosition:'');
      } else {
        prettifiedContent = content;
      }
      return this.saveFileContent(this.getFileUrl(this.activePageName, this.activeTab), prettifiedContent)
        .then(() => {
          this.savedStackLength = currentStackLength;
          this.postSave(this.activeTab, content, prettifiedContent)
            .then(() => {
              if (this.activeTab !== TABS.DESIGN) {
                this.editor.resetEditorContentChange();
                if (editorPosition.currentPosition && this.editor.wmsEditor) {
                  this.editor.wmsEditor.setPosition(editorPosition.currentPosition);
                  if (editorPosition.currentSelectionRange) {
                    this.editor.wmsEditor.setSelection(editorPosition.currentSelectionRange);
                  }
                  this.editor.wmsEditor.setScrollPosition({
                    scrollTop: editorPosition.currentScrollTop,
                    scrollLeft: editorPosition.currentScrollLeft
                  });
                }
              }
              this.updatePageParams()
                .then(() => {
                  this.eventManager.emitOnPageSave(this.activePageName);
                });
            });

        }).then(() => {
          this.isDirty(); });
    }
    return Promise.resolve();
  }

  updatePageParams(): Promise<any> {
    let pagesInfo;

    if (this.isPageParamsUpdated) {
      pagesInfo = this.projectService.getPageInfo(this.activePageName);
      pagesInfo.params = this.pageParams;
      return (this.pageService.update({
        'pageName': this.activePageName,
        'data': pagesInfo
      }) as Promise<any>).then(() => {
        this.isPageParamsUpdated = false;
      });
    }
    return Promise.resolve();
  }

  postSave(tab: string, content: any, prettifiedContent: any) {
    this.markPristine();
    // wmToaster.show('success', $rs.locale.MESSAGE_SUCCESS_TITLE, $rs.locale.MESSAGE_SUCCESS_SAVE_FILE_DESC);
    if (tab === TABS.VARIABLES) {
      // $rs.$emit('update-page-variables', activePageName, content);
    }

    if (tab !== TABS.DESIGN) {
      // this.editor.setEditorValue(prettifiedContent);
      this.markupUpdated = true;
    } else {
      if (this.saveVariables) {
        this.baseVariableService.saveVariables(this.activePageName).then(() => {
          this.saveVariables = false;
        });
      }
    }
    if(this.issuesService.isAPIIssuesTabOpened)
      this.eventManager.emitRefreshAPIIssues();
    return Promise.resolve();
  }

  markPristine() {
    if (!this.activeTab) {
      return;
    }

    if (this.activeTab === TABS.DESIGN) {
      this.widgetPropertyChanged = false;
      this.eventManager.emitOnWidgetPropChanged(false);
    } else {
      // $s.ws.editor.setPristine();
    }
  }

  resetActiveWidget() {
    this.eventManager.emitResetActiveCanvasEl('');
    // this.activeWidget = undefined;
    // $rootScope.$emit('reset-active-widget');
  };

  saveFileContent(url: string, content: any, allowTemplateSave?: boolean) {
    if (allowTemplateSave) {
      // This flag will prevent the pageName comparison. This is handled for creating widgetTemplate and save the widget template into new page from the current page.
      return this.fileService.write(url, content);
    }
    this.resourceMngr.removeUrlCache(this.activePageName);
    if (this.selectedPageName !== this.activePageName || (url.includes('pages/') && !url.includes('pages/' + this.activePageName))) {
      console.error('File name: ' + this.activePageName + ' and url ' + url + ' containing the name is not the same.');
      throw Error(`File name: ${this.activePageName} and url ${url} containing the name is not the same.`);
      return Promise.reject();
    }

    if(this.activeTab !== TABS.DESIGN) {
      const tab = url.endsWith(".html") ? TABS.MARKUP : (url.endsWith(".js") ? TABS.SCRIPT : (url.endsWith(".css") ? TABS.STYLE : null));
      if (tab && !this.isContentMatchingTab(content, tab)) {
        console.error(`[Save Guard] Content-tab mismatch: target tab="${tab}" and activeTab="${this.activeTab}" and saving url="${url}"`);
        return Promise.reject();
      }
    }
    return this.fileService.write(url, content,false).then(() => {
      let data: any = {};
      if (url.endsWith('/' + this.activePageName + '.html')) {
        data.type = 'html';
        data.value = content;
      }
      else if (url.endsWith('/' + this.activePageName + '.js')) {
        data.type = 'script';
        data.value = content;
      }
      else if (url.endsWith('/' + this.activePageName + '.css')) {
        data.type = 'style';
        data.value = content;
      }
      else if (url.endsWith('/' + this.activePageName + 'variables.json')) {
        data.type = 'variables';
        data.value = content;
      }

      if (!isEmpty(data)) {
        this.eventManager.emitUpdatePageMinJson(data);
      }
    });
  }

  private isContentMatchingTab(content: string, tab: string): boolean {
    if (tab === TABS.DESIGN || tab === TABS.VARIABLES) return true;

    const tabToLanguage: Record<string, string> = {
      [TABS.MARKUP]: 'html',
      [TABS.SCRIPT]: 'javascript',
      [TABS.STYLE]: 'css',
    };

    const expectedLanguage = tabToLanguage[tab];
    if (!expectedLanguage) return true;

    const trimmed = content?.trim();
    if(!trimmed) return true;

    if(expectedLanguage === 'html') {
       return this.isHtml(trimmed);
    }
    else if(expectedLanguage === 'javascript' || expectedLanguage === 'css') {
       return !this.isHtml(trimmed);
    }
    return true;
  }

  private isHtml(content: string): boolean {
    const tags = ["<wm-template", "<wm-page", "<wm-partial", "<wm-prefab", "<wm-prefab-container"];
    return tags.some(p => content.includes(p)) || content.includes("<wm-content") || content.includes("<wm-page-content");
  }

  getFileUrl(pageName: string, tab: string) {
    let extension,
      urlPrefix = PAGE_DIRECTORY  + pageName + '/';

    switch (tab) {
      case TABS.DESIGN:
      case TABS.MARKUP:
        extension = 'html';
        break;
      case TABS.SCRIPT:
        extension = 'js';
        break;
      case TABS.STYLE:
        extension = 'css';
        break;
      case TABS.VARIABLES:
        extension = 'variables.json';
        break;
    }

    return urlPrefix + pageName + '.' + extension;
  }

  getFileContentWithTimeout(url: string) {
    // Fix: this is added to resolve the expression changed error while setting the spinner.show value from false to true.
    return new Promise(resolve => {
      setTimeout(() => {
        resolve(this.fileService.read(url, true));
      })
    })
  }

  getFileContent(url: string) {
    return this.fileService.read(url, true);
  }

  loadFiles(pageName: string, useCache: boolean = true) {
    let url = environment.SERVICES_BASE_PATH + `services/projects/${this.projectService.getProjectId()}/pages/${pageName}/page.min.json`;
    return  this.resourceMngr.get(url, useCache);
  }

  load(details: PageDetails): Promise<any> {
    let pageName = details.pageName || '',
      tab = details.tab || '';

    let renderWidgets: boolean = (this.activePageName && pageName !== this.activePageName) || (tab === TABS.DESIGN);

    return this.loadFiles(pageName)
      .then((response: any) => this.processResponse(pageName, tab, renderWidgets, response), (err: any) => Promise.reject(err))
      .then(() => {
        this.populatePageInfo(pageName);
        this.eventManager.emitCreatepartialvariable(this.activePageInfo);
        // $rs.$emit("create-partial-variable");
        this.activeTab = tab;
        // $rs._toBeActivatedPage = undefined;
      }, Promise.reject);
  }

  pageParamsInit(pageName: string) {
    // get page params info, assign to scope (to be used by properties.html)
    let pageInfo   = this.projectService.getPageInfo(pageName);
    let pageParams = pageInfo.params;
    if (!pageParams) {
      pageParams = pageInfo.params = [];
    }
    this.pageParams =  pageParams;
    this.newParam = {name: '', type: 'string'};
  }

  assignParams(widget: any) {
    let pageInfo = this.projectService.getPageInfo(widget.content);
    runtimeEventManager.emit('partialParams', pageInfo.params);
  }

  populatePageInfo(pageName: string) {
    this.pageInfo.type      = this.projectService.getPageInfo(pageName).type || PAGE;
    this.pageInfo.name      = pageName;
    this.pageInfo.isPartial = this.pageInfo.type !== PAGE;
    this.activePageInfo    = this.pageInfo;
  }

   updateVariables(pageName:any, contents:any) {
    this.baseVariableService.setPageVariables(pageName, getValidJSON(contents.variables));
  }

  processResponse(pageName: string, tab: string, renderWidgets: boolean, content: any): Promise<any> {
    if (typeof (content) === 'string') {
      content = JSON.parse(content);
    }
    let contents = this.splitMinFileContent(pageName, content);

    // need to check
    let eventData = this.wmsUpdateTemplateBindings(undefined, contents.html, this);
    if (eventData.template) {
      contents.html = eventData.template;
    }

    // TODO: update variable before re-rendering canvas
   this.updateVariables(pageName, contents);

    if (renderWidgets) {
      // promise TODO
      this.renderCanvasContent(pageName, contents);
    }

    if (tab !== TABS.DESIGN) {
      this.processEditorResponse(pageName, tab, contents);
      return Promise.resolve();
    }
    if (eventData.template) {
      this.resourceMngr.removeUrlCache(pageName);
      return this.saveFileContent(this.getFileUrl(pageName, TABS.DESIGN), eventData.template, true).then(() => {
        this.updatePageParams().then(() => {
          this.markPristine();
          return Promise.resolve();
        }, Promise.reject)
      }, Promise.reject);
    }
    return Promise.resolve();
  }

  splitMinFileContent(pageName: string, minFileContent: any, isdecoded?: boolean) {
    let data;
    if (isdecoded) {
      data = {
        html: minFileContent.markup,
        script: minFileContent.script,
        style: minFileContent.styles,
        variables: minFileContent.variables
      };
    } else {
      data = {
        html: getDecodedData(minFileContent.markup),
        script: getDecodedData(minFileContent.script),
        style: getDecodedData(minFileContent.styles),
        variables: getDecodedData(minFileContent.variables)
      };
    }
    this.eventManager.emitPageMarkupResponse(data);
    return data;
  }

  async processEditorResponse(pageName: string, tab: string, contents: any) {
    let editorType, content;

    this.eventManager.emitPageMarkupResponse(contents);

    switch (tab) {
      case TABS.MARKUP:
        content    = contents.html;
        editorType = 'html';
        // this.editor.options = {...this.editor.options, value: content, language: "html"}
        break;
      case TABS.SCRIPT:
        content    = contents.script;
        editorType = 'js';
        break;
      case TABS.STYLE:
        content    = contents.style;
        editorType = 'css';
        break;
      case TABS.VARIABLES:
        content    = contents.variables;
        content    = isString(content) ? trim(content) : content;
        content    = await this.prettifyContent(content, TABS.VARIABLES);
        editorType = 'json';
        break;
    }
    this.eventManager.emitUpdatePageData({
      markup: contents.html,
      script: contents.script,
      styles: contents.style,
      variables: contents.variables,
      tab: tab
    });
  }

  prepareMarkup(content: any) {

    let markupStr = content;

    // markupStr = Utils.getValidMarkUp(markupStr, hideCanvasMessage, function () {
    //     showCanvasMessage('error', $rs.locale.MESSAGE_ERROR_MARKUP);
    // });
    //
    //
    // if (!markupStr) {
    //     markupStr = PageLayoutsService.getLayoutMarkup('blank');
    // }

    // Initializing an empty function as the js file of the page is not compiled in studio mode
    return markupStr;
  }

  isCanvasInitialized() {
    return $(getCanvasElement()).length;
  }

  onEditorChange() {
    if(this.activeTab !== 'DESIGN') {
      this.startAutoSave();
    }
    this.markupUpdated = true;
  }

  renderCanvasContent(pageName: string, contents: any) {
    // [WMS-16473] Sometimes Pagename is getting undefined when we refresh(Ctrl+Shift+R) the page.
    // _toBeActivatedPage is getting undefined before the canvas dom is rendered as the promises in loadFiles are executed synchronously.
    let markup, deregister;

    markup = this.prepareMarkup(contents.html);
    // if ($rs.isNativeMobileApplicationType) {
    //   // getFileContent('../project/generated-rn-app/designtime/pages/'+ pageName + '/' + pageName + '.css',)
    //   //   .then(function(style) {
    //   //     loadStyles(pageName, style);
    //   //   });
    // } else {
    this.loadStyles(pageName, contents.style);
    // }
    this.findLayoutFromMarkup(markup);

    // $rs._toBeActivatedPage = pageName;

    if (this.isCanvasInitialized()) {
      // $rs.$emit('render-canvas-content', markup);
      // TODO: remove this
      // this.markupUpdated = false;
      // this.eventManager.emitRenderCanvasContent(markup, pageName, contents, this.markupUpdated);
      // deferred.resolve();
    } else {
      // deregister = $rs.$on('canvas-initialize', () => {
      //   deregister();
      //   $rs.$emit('render-canvas-content', markup);
      //   deferred.resolve();
      // });
    }
    // return deferred.promise;
  }

  findMatch(_markupDetails: any, layout: any) {
    return isEqual(layout.details.sort(), _markupDetails);
  }

  findLayoutFromMarkup(markup: HTMLElement) {
    let $markup       = $(markup),
      markupDetails: any[] = [],
      layoutParts   = extend({}, layoutWidgetTypes, {
        'wm-mobile-navbar' : 'NAVBAR',
        'wm-mobile-tabbar' : 'TABBAR'
      });

    forEach(layoutParts, function (value, key) {
      if ($markup.find(key).length > 0) {
        markupDetails.push(value);
      }
    });

    this.layout = find(this.newPageLayouts, this.findMatch.bind(undefined, markupDetails.sort()));
  }

  loadStyles(pageName: string, content: any) {
    if (!$('style' + '.' + pageName).length) {
      $('.canvas-container').append('<style class="' + pageName + '" scoped>' + content + '</style>');
    } else {
      $('style' + '.' + pageName).html(content);
    }
  }

  postWSRender(details: PageDetails) {
    // TODO condition changed: details.tab === TABS.SCRIPT && details.cursorPosText
    if (details.tab === TABS.SCRIPT) {

      // $timeout(function () {
      //   var editor = $s.ws.editor;
      //   editor.$setCursorAt(details.cursorPosText);
      // });
    } else if (details.tab === TABS.DESIGN) {
      if (details.pageName === this.activePageName) {
        this.eventManager.emitReRenderCanvasContent({pageName: this.activePageName, isMarkupUpdated: this.markupUpdated});
        this.markupUpdated = false;
      }
      // $rs.$emit('wms:set-widgets-group-active');
      // $rs.$emit("update-variables-tree");
    }

    // highlight the selected page in the pages list accordion
    // $timeout(function () {
    $('ul.pages-list > li.page.active').focus();
    // });
  }

  wmsUpdateTemplateBindings(event: any = {}, template: string, scope: any) {
    let widgetEl: JQuery<HTMLElement>, templateObj = $("<div>" + template + "</div>");
    if (get(this.template.selected, 'type') === 'template' && get(this.createdVariable, 'isNew') === true) {
      // updating template bindings
      if (this.templateWidgets) {
        // adding item as partial param
        let newParam = {'name': 'item', 'type': 'string'};
        scope && scope.addNewParam(newParam);
        forEach(this.templateWidgets, (widget) => {
          widgetEl = templateObj.find('[name="' + widget['name'] + '"]');
          forEach(widget['widgetProps'], (prop: any) => {
            //If label widget and prop is caption and it is not mapped to any field, map it with its name
            if (widget['type'] === 'wm-label' && prop['name'] === 'caption' && !prop.value) {
              prop.value = widget['name'];
            }
            widgetEl?.attr(prop.name, prop.value);
          });
        });
        event.template = templateObj.html();
      }
    }
    return event;
  };

  //To retain the previous value when user empties the param name field before he created a new record
  onParamNameChange(param: any, oldName: any) {
    //Validates the latest param name for having special characters
    if (hasSpecialCharacters(param.name)) {
      // wmToaster.show('error', $rs.locale.MESSAGE_ERROR_TITLE, $rs.locale.MESSAGE_SPECIAL_CHARACTERS_NOT_ALLOWED);
      param.name = oldName;
      return;
    }

    if (!param.name) {
      param.name = oldName;
    }
  }

  /**
   * makes the page workspace dirty(required for save action)
   */
  onPageParamsUpdate() {
    this.isPageParamsUpdated = true;
    this.setWidgetPropertyChangedFlg(true);
    this.projectService.getPageInfo(this.activePageName).params = this.pageParams;
  }

  setWidgetPropertyChangedFlg(flag: boolean) {
    this.widgetPropertyChanged = flag;
    if(flag){
      this.startAutoSave();
    }
  }

  /**
   * adds new param to the list of page params
   * @param newParam, new param object
   */
  addNewParam(newParam: any) {
    if (!newParam.name) {
      // wmToaster.show('error', $rs.locale.MESSAGE_ERROR_TITLE, Utils.replace($rs.locale.MESSAGE_WARN_NAME_EMPTY_DESC, ['Param']));
    } else {
      // wmToaster.hide();
      if (hasSpecialCharacters(newParam.name)) {
        // wmToaster.show('error', $rs.locale.MESSAGE_ERROR_TITLE, $rs.locale.MESSAGE_SPECIAL_CHARACTERS_NOT_ALLOWED);
      } else {
        let paramsName = map(this.pageParams, "name");
        if (!isDuplicateName(paramsName, newParam.name)) {
          this.pageParams.push(newParam);
          this.newParam = {'name': '', 'type': 'string'};
          this.onPageParamsUpdate();
          $('[name="wm-new-input-param"] input').focus();
        }
        else {
          // wmToaster.show('error', $rs.locale.MESSAGE_ERROR_TITLE, $rs.locale.MESSAGE_ERROR_DUPLICATE_FIELDS);
        }
      }
    }
  }

  isUndoDisabled() {
    return !this.wmCommand.isUndoPossible();
  }
  isRedoDisabled() {
    return !this.wmCommand.isRedoPossible();
  }

  undo(propPanel?: PropertiesPanelComponent, canvasComponent?: WmsCanvasDomComponent) {
    this.wmCommand.undo(propPanel, canvasComponent);
    this.isWmEventTriggered = true
    this.startAutoSave();
  }
  redo(propPanel?: PropertiesPanelComponent, canvasComponent?: WmsCanvasDomComponent) {
    this.wmCommand.redo(propPanel, canvasComponent);
    this.isWmEventTriggered = true
    this.startAutoSave();
  }

  validatePageSizeOptions(pageSizeInput: string) {
    if(pageSizeInput.includes("bind:")) {
      return pageSizeInput;
    }
    // Split input, trim values, and convert to numbers
    let inputValues = pageSizeInput
      .split(',')
      .map(val => val.trim())
      .filter(val => val !== '') // Remove empty values
      .map(val => Number(val)); // Convert to numbers

    // Filter: Remove invalid entries (zero, negative, decimal)
    let cleanedValues = inputValues.filter(val => Number.isInteger(val) && val > 0);

    // Remove duplicates
    cleanedValues = Array.from(new Set(cleanedValues));

    // If cleaning removed any invalid values, show a warning
    if (cleanedValues.length !== inputValues.length) {
      const warningMessage = 'Invalid or duplicate entries were removed. Page Size options must be positive whole numbers only — no decimals, negatives, or zeros.';
      this.notificationService.show('warning', this.locale.MESSAGE_WARNING_TITLE, warningMessage, {timeOut : 10000});
    } else {
      this.notificationService.hide();
    }
    return cleanedValues.sort((a, b) => a - b).join(',')
  }


  selectLayout($event: any, layout: any) {
    $event.stopPropagation();
    if (layout.selected) {
      return;
    }
    const activeElement:any = this.markupManager.getActiveMarkupEl();
    if(activeElement.parent()[0].getAttribute("widgettype") == "wm-composite"){
      if(layout.properties["type"]){
        delete layout.properties["type"];
        layout = {...layout.properties};
      }
    }
    this.setActive(this.layoutOptions, layout);
    runtimeEventManager.emit('canvas-switch-layout', {
      pageName: activePageName,
      layoutInfo: layout
    });
  }

  setActive(options: any, item: any) {
    if (!item) {
      return;
    }
    each(options, (t: any) => { t.selected = false; });
    item.selected = true;
  }





  showTemplateMenu($event: any, show: any) {
    this.templateMenu['visible'] = show === undefined ? !this.templateMenu['visible'] : show;
    if ($($event.currentTarget).find('.iScrollVerticalScrollbar').length > 0) {
      this.templateMenu['iScroll']?.refresh();
      return;
    }
    setTimeout(() => {
      let scrollable = $($event.currentTarget).parent().find('.wm-template-list:first');
      let dismissOnOutsideClick = true;
      let onExternalClick = (event: any) => {
        if (!dismissOnOutsideClick || $(event.target).hasClass('wms-template-layout')) {
          return;
        }
        this.templateMenu['visible'] = false;
        $(event).off('click', onExternalClick);
        // $rs.$safeApply($s);
      };
      $(document).on('click', onExternalClick);
      if (this.templateMenu && this.templateMenu.iScroll) {
        this.templateMenu.iScroll.destroy();
      }
      // TODO
      // this.templateMenu['iScroll'] = new IScroll(scrollable[0], {
      //     'mouseWheel': true,
      //     'scrollbars': true,
      //     'click': true,
      //     'bounce': false
      // });
    }, 200);
  }


  toggleHiddenElements() {
    this.showHiddenElements = !this.showHiddenElements
    //update storage value based on header button toggle changes
    localStorage.setItem("showHiddenElements", this.showHiddenElements === true ? 'true' : 'false');
    this.showHideComponentsBasedOnMarkup();
  }


  showHideComponentsBasedOnMarkup() {
    let markup, hiddenElements: any, registry = getWidgetRegistry();
    markup = this?.markupManager?.getMarkup();
    hiddenElements = markup?.find("[show='false']");
    hiddenElements?.each((elementIndex: any, element: any) => {
      let widgetId, widgetName, widgetType, widgetElement;
      widgetId = element.getAttribute("widgetId")
      widgetName = element.getAttribute("name");
      widgetType = element.getAttribute("widgetType");
      widgetElement = widgetName && registry?.get(widgetId)?.nativeElement;
      if (widgetElement) {
        this.showHiddenElements ? widgetElement.removeAttribute("hidden") : widgetElement.setAttribute('hidden', 'true');
        this.handleHideAndShowOverlay(this.showHiddenElements, widgetElement, widgetType, widgetId);
      }
    })
  }

  //supports to show and hide hidden elements, Params -> showHiddenElements (read value from storage), widgetElement (element on which show hide to be performend), widgetType (type of widget), widgetId (id of the widget)
  handleHideAndShowOverlay(showHiddenElements: Boolean, widgetElement: any, widgetType: string, widgetId: string) {
    var parentWrapperElement, $hiddenEleNode, $hiddenEl, $wrapper, isWizardOrProgressCircleWidget = (widgetType === 'wm-wizardstep' || widgetType === "wm-progress-circle");
    parentWrapperElement = this.getWidgetContainer(widgetElement, widgetType, widgetId);
    //adds wm-hidden-overlay overlay wrapper on parentWrapperElement of widget
    if (showHiddenElements) {
      $hiddenEleNode = $('<div class="wm-hidden-overlay ' + widgetType + '" title="' + this.locale.LABEL_HIDDEN_WIDGET + '"></span></div>');
      if (widgetType === "wm-picture") {
        $wrapper = $('<div class="picture-wrapper" widgetid="' + $(widgetElement).attr("widgetid") + '" name="' + $(widgetElement).attr("name") + '" widgettype="wm-picture"></div>')
        $(widgetElement).wrap($wrapper);
        $(".picture-wrapper").append($hiddenEleNode);
      } else {
        isWizardOrProgressCircleWidget ? $(parentWrapperElement).addClass('wm-hidden-overlay ' + widgetType) : $(parentWrapperElement).append($hiddenEleNode);
      }
    }
    //removes wm-hidden-overlay overlay wrapper on parentWrapperElement of widget
    else {
      if (widgetType === "wm-picture") {
        $wrapper = $(widgetElement).closest(".picture-wrapper");
        $($wrapper).find('.wm-hidden-overlay').remove();
        $(widgetElement).unwrap();
      } else {
        if (isWizardOrProgressCircleWidget) {
          $(parentWrapperElement).removeClass('wm-hidden-overlay ' + widgetType);
        } else {
          $hiddenEl = $(parentWrapperElement).find('.wm-hidden-overlay.' + widgetType);
          $hiddenEl.remove();
        }
      }
    }
  }

  //this function returns parent wrappper element of the widget where we need to append wm-hidden-overlay
  getWidgetContainer(widgetElement: any, widgetType: string, widgetId: string) {
    let parentWrapperElement, registry = getWidgetRegistry();
    switch (widgetType) {
      case 'wm-accordionpane':
        parentWrapperElement = $(widgetElement).find('.panel-heading');
        break;
      case 'wm-text':
      case 'wm-number':
      case 'wm-select':
      case 'wm-textarea':
        parentWrapperElement = $(widgetElement).closest('div');
        break;
      case 'wm-tabpane':
      case 'wm-wizardstep':
        let tabContentElement, tabParentElement, closestElement, selectorElement;
        //To find the closest & selector elements of the tabpane, wizard step
        if (widgetType === "wm-tabpane") {
          closestElement = ".app-tabs";
          selectorElement = "data-paneid";
        } else {
          closestElement = ".app-wizard";
          selectorElement = "data-wizardstepid"
        }
        closestElement = widgetType === "wm-tabpane" ? ".app-tabs" : ".app-wizard";
        tabContentElement = widgetId && registry.get(widgetId)?.nativeElement;
        tabParentElement = tabContentElement && $(tabContentElement)?.closest(closestElement)[0];
        parentWrapperElement = tabParentElement?.querySelector(`[${selectorElement}=${widgetId}]`);
        this.showHiddenElements ? parentWrapperElement.removeAttribute("hidden") : parentWrapperElement?.setAttribute('hidden', 'true');
        break;
      default:
        parentWrapperElement = $(widgetElement);
        break;
    }
    return parentWrapperElement;
  }

  loadAvailableDeviceTypes() {
    if (this.availableDevices) {
      return this.availableDevices;
    }
    let FILE_NAME = 'devices.json';
    let project = this.projectService.getDetails();
    let ROOT_DIR = '../../../../../deviceTypes/';
    let MODE = {
      'DESIGN': 'DESIGN',
      'PREVIEW': 'PREVIEW'
    }
    import(`./../../design-container/deviceTypes/${project.type.toLowerCase()}/${project.platformType.toLowerCase()}/devices.json`)
      .then((module) => {
          let response = module.default;
          let devices: any[] = [];
          if (isObject(response)) {
            Object.keys(response)
              .forEach((category: string) => {
                var categoryDetails = get(response, category),
                  deviceTypesByCategory;
                if (categoryDetails.modes.indexOf(MODE.DESIGN) !== -1) {
                  deviceTypesByCategory = categoryDetails.devices.filter((deviceType: any) => {
                    if (deviceType.support.indexOf("DESIGN") !== -1) {
                      deviceType.category = category;
                      if (deviceType.default) {
                        this.selectedViewPort = deviceType;
                        this.eventManager.emitViewportSelection(this.selectedViewPort);
                      }
                      return deviceType;
                    }
                  });

                  devices = devices.concat(deviceTypesByCategory);
                }
              });
          }
          if (this.projectService.isNativeMobileApplicationType() || this.projectService.isMobileApplicationType()) {
            this.availableDevices = devices.reverse();
          } else {
            this.availableDevices = devices;
          }
        }
      );
  }

  canvasResize(selectedCanvas: any) {
    this.selectedViewPort = selectedCanvas;
    this.eventManager.emitViewportSelection(this.selectedViewPort);
    if(selectedCanvas.category == 'Web') {
      this.showCanvasFitScreen = selectedCanvas.id=="fullscreen" ? true: false;
    } else {
      // invoked only for native mobile project canvas change.
      const isTablet: boolean = get(selectedCanvas, 'category') === 'Tab';
      this.projectService.setTabletType(isTablet);

      runtimeEventManager.emit('on-studio-services-initialized');
      runtimeEventManager.emit('selected-canvas-change');
    }
  }
  toggleToolsPanelDisplay() {
    this.hideResources = this.hideResources === true ? false : true;
    this.hideEditorProperties = this.hideEditorProperties === true ? false : true;
    $(".workspace-header").toggleClass("width_100");

  }


  changeEditorTheme($event: Event): void {
    this.editorOptions = { ...this.editorOptions, theme: ($event.target as HTMLInputElement).value, value: this.editor.wmsEditor.getValue() };
  }

  changeEditorFontSize($event: Event): void {
    this.editorOptions = { ...this.editorOptions, fontSize: parseInt(($event.target as HTMLInputElement).value), value: this.editor.wmsEditor.getValue() };
  }


  startAutoSave(forceSave: boolean = false): void {
    clearTimeout(this.saveTimeout);
    const skipPrettify = !forceSave && this.activeTab !== TABS.DESIGN; // Prettify on manual save (Ctrl+S), skip on auto save (cursor preservation)
    const executeSave = async () => {
      if (!forceSave && (!this.isDirty() || this.isSaving)) {
        return;
      }
      this.showAutoSave = true;
      this.isSaving = true;
      const changesListWhileSaving = this.wmCommand.getUndoStackLength();
      // Cache editor content before save
      if (this.editor?.wmsEditorModel ) {
        this.savedEditorContent = this.editor.wmsEditorModel.getValue() || '';
      }
      await this.saveActiveTabContent(true, skipPrettify);
      this.savedStackLength = changesListWhileSaving;
      this.isSaving = false;
    };

    if (forceSave) {
      executeSave();
    } else {
      this.saveTimeout = setTimeout(executeSave, this.SAVE_INTERVAL);
    }

  }






  stopAutoSave(): void {
    clearTimeout(this.saveTimeout);
    this.savedStackLength = 0;
    this.wmCommand.reset();
  }

  ngOnDestroy() {
    this.registerDestroyListener.unsubscribe();
    runtimeEventManager.off();
  }
}
